/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseEntryFileMetaData
 */
export interface DatabaseEntryFileMetaData {
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    fileExtension: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    dataAsBase64?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    resourceIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    uploadedBy?: string;
    /**
     * Dateigröße in Bytes
     * @type {number}
     * @memberof DatabaseEntryFileMetaData
     */
    fileSize?: number;
    /**
     * Bildbreite in Pixel
     * @type {number}
     * @memberof DatabaseEntryFileMetaData
     */
    width?: number;
    /**
     * Bildhöhe in Pixel
     * @type {number}
     * @memberof DatabaseEntryFileMetaData
     */
    height?: number;
    /**
     * Dauer in Sekunden (Video/Audio)
     * @type {number}
     * @memberof DatabaseEntryFileMetaData
     */
    duration?: number;
    /**
     * Dateiname des serverseitig erzeugten Thumbnails (JPEG, max. 600px Breite)
     * @type {string}
     * @memberof DatabaseEntryFileMetaData
     */
    thumbnailIdentifier?: string;
    /**
     * Kennzeichnet ein KI-generiertes Bild (Transparenzpflicht ab 08/2026); Anzeige als "AI"-Badge.
     * @type {boolean}
     * @memberof DatabaseEntryFileMetaData
     */
    aiGenerated?: boolean;
}

/**
 * Check if a given object implements the DatabaseEntryFileMetaData interface.
 */
export function instanceOfDatabaseEntryFileMetaData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "mimeType" in value;
    isInstance = isInstance && "fileExtension" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DatabaseEntryFileMetaDataFromJSON(json: any): DatabaseEntryFileMetaData {
    return DatabaseEntryFileMetaDataFromJSONTyped(json, false);
}

export function DatabaseEntryFileMetaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryFileMetaData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mimeType': json['mimeType'],
        'fileExtension': json['fileExtension'],
        'name': json['name'],
        'dataAsBase64': !exists(json, 'dataAsBase64') ? undefined : json['dataAsBase64'],
        'resourceIdentifier': !exists(json, 'resourceIdentifier') ? undefined : json['resourceIdentifier'],
        'uploadedBy': !exists(json, 'uploadedBy') ? undefined : json['uploadedBy'],
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'thumbnailIdentifier': !exists(json, 'thumbnailIdentifier') ? undefined : json['thumbnailIdentifier'],
        'aiGenerated': !exists(json, 'aiGenerated') ? undefined : json['aiGenerated'],
    };
}

export function DatabaseEntryFileMetaDataToJSON(value?: DatabaseEntryFileMetaData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'mimeType': value.mimeType,
        'fileExtension': value.fileExtension,
        'name': value.name,
        'dataAsBase64': value.dataAsBase64,
        'resourceIdentifier': value.resourceIdentifier,
        'uploadedBy': value.uploadedBy,
        'fileSize': value.fileSize,
        'width': value.width,
        'height': value.height,
        'duration': value.duration,
        'thumbnailIdentifier': value.thumbnailIdentifier,
        'aiGenerated': value.aiGenerated,
    };
}

